module.exports = __webpack_public_path__ + "img/th.9c1e01fc.svg";